export default function AppSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">APP下载</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">随时随地畅享高清影视，下载91影视看片app</p>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-100 rounded-2xl p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="font-display text-xl md:text-2xl text-foreground-950 mb-3">
                91影视看片app 移动客户端
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                支持iOS与Android双平台，高清电影在线观看、蓝光影视资源、高清电视剧免费全集和超清综艺播放，一站尽享。下载即可获得7天免费VIP体验，解锁4K蓝光画质与离线缓存功能。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                  <i className="ri-android-fill text-lg"></i>
                  Android APK
                </div>
              </div>

              <p className="text-xs text-foreground-400 mt-3">
                或扫描右侧二维码直接下载安装
              </p>
            </div>

            <div className="flex-shrink-0">
              <div className="w-36 h-36 md:w-44 md:h-44 bg-background-50 rounded-2xl flex items-center justify-center border-2 border-background-300">
                <div className="text-center">
                  <i className="ri-qr-code-line text-5xl md:text-6xl text-foreground-400"></i>
                  <p className="text-[10px] text-foreground-400 mt-1">扫码下载</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-6 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-accent-500"></i> 安全无毒
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-download-cloud-2-line text-accent-500"></i> 极速下载
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-device-line text-accent-500"></i> 全设备兼容
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}